angular.module('core')
    .service('dblActivityFactoryService', [
        'DblActivity',
        'moment',
    function(
        DblActivity,
        moment
    ) {
        function create (activityRecord) {
            return new DblActivity(activityRecord);
        }

        function createLessonGroupInProgressFromLessonComplete(activity) {
            return create({
                dbl_standard: _.cloneDeep(activity.dblStandard),
                // if we have a null demo lesson, let's see if we can get a lesson name to use instead
                demo_lesson_name: activity.demoLessonName ? activity.demoLessonName : activity.lessonSlotName,
                event_code: DblActivity.EVENT_CODES.LESSON_GROUP_IN_PROGRESS,
                id: DblActivity.EVENT_CODES.LESSON_GROUP_IN_PROGRESS + '_' + activity.dblStandard.name,
                lessons_in_group_count: 1,
                needs_attention: false,
                standards: _.cloneDeep(activity.standards),
                student_id: activity.studentId,
                timestamp: activity.timestamp,
                total_lesson_time: activity.totalLessonTime
            });
        }

        // track failures for lessons within a lesson group to
        // calculate "needs attention"
        function LessonGroupNeedsAttentionCalculator () {
            var lessonStates = {};

            function getLessonState (lessonSlotId) {
                var lessonState = lessonStates[lessonSlotId];
                if (!lessonState) {
                    lessonState = {
                        fails: 0,
                        lastWasFail: false,
                        momentOfLatestPlay: undefined
                    };

                    lessonStates[lessonSlotId] = lessonState;
                }

                return lessonState;
            }

            this.recordLessonResult = function (lessonSlotId, failed, timestamp) {
                if (!_.isBoolean(failed) || lessonSlotId === undefined || lessonSlotId === null || !timestamp) {
                    return;
                }

                var lessonState = getLessonState(lessonSlotId);
                lessonState.fails += failed ? 1 : 0;

                var momentOfPlay = moment(timestamp);
                if (!lessonState.momentOfLatestPlay || lessonState.momentOfLatestPlay.isBefore(momentOfPlay)) {
                    lessonState.lastWasFail = failed;
                    lessonState.momentOfLatestPlay = momentOfPlay;
                }
            };

            this.needsAttention = function () {
                // if any lesson in the group meets the criteria then the lesson group
                // needs attention

                return _.reduce(lessonStates, function (needsAttention, lessonState) {
                    return needsAttention || (lessonState.fails > 1 && lessonState.lastWasFail);
                }, false);
            };
        }

        // From a list of activities for a student, extract copies of lesson group completed
        // events with total lesson time and lessonsInGroupCount updated to reflect only the lessons present in the activities list.
        function getLessonGroupsCompleted (studentActivities) {
            var lessonGroupsCompleted = _.chain(studentActivities)
                .filter(function (activity) {
                    return activity.dblStandard && activity.isLessonGroupCompletedActivity();
                })
                .map(function (activity) {
                    var activityCopy = _.cloneDeep(activity);
                    activityCopy.lessonsInGroupCount = 0;
                    activityCopy.id = activityCopy.eventCode + '_' + activityCopy.dblStandard.name;

                    return activityCopy;
                })
                .indexBy(function (activity) {
                    return activity.dblStandard.name;
                })
                .value();


            _.chain(studentActivities)
               .filter(function (activity) {
                   // only care about the lesson/lesson group complete activities with dbl standards attached
                   return activity.dblStandard && activity.isLessonCompleteActivity();
               })
               .each(function (activity) {
                   var lessonGroup = lessonGroupsCompleted[activity.dblStandard.name];

                   if(!lessonGroup) {
                       return;
                   }

                   lessonGroup.lessonsInGroupCount++;

                   addToTotalLessonTime(lessonGroup, activity);
               })
               .value();

            return _.values(lessonGroupsCompleted);
        }

        // From a list of activities for a student, generate a list
        // of synthetic lesson group in progress events.
        function getLessonGroupsInProgress (studentActivities) {
            var needsAttentionCalculators = {};

            return _.chain(studentActivities)
                .filter(function (activity) {
                    // only care about the lesson/lesson group complete activities with dbl standards attached
                    return activity.dblStandard && (activity.isLessonCompleteActivity() || activity.isLessonGroupCompletedActivity());
                })
                .reduce(function (lessonGroups, activity) {
                    // just store lesson group completes so we can skip lessons in these groups
                    if (activity.isLessonGroupCompletedActivity()) {
                        lessonGroups[activity.dblStandard.name] = activity;
                    }

                    // if we've seen lesson group complete for this activity's standard, then no
                    // need to consider this activity any further
                    var lessonGroup = lessonGroups[activity.dblStandard.name];
                    if (lessonGroup && lessonGroup.isLessonGroupCompletedActivity()) {
                        return lessonGroups;
                    }

                    // handle lesson complete activity
                    var needsAttentionCalculator = getNeedsAttentionCalculator(needsAttentionCalculators, activity.dblStandard.name);
                    needsAttentionCalculator.recordLessonResult(activity.lessonSlotId, activity.lessonPassed === false, activity.timestamp);

                    if(!lessonGroup) {
                        var newActivity = createLessonGroupInProgressFromLessonComplete(activity);

                        lessonGroups[activity.dblStandard.name] = newActivity;
                    } else {
                        updateLessonGroupInProgressFromLessonComplete(lessonGroup, activity);
                    }

                    return lessonGroups;
                }, {})
                .filter(function (activity) {
                    // only keep the in progress ones
                    return activity.isLessonGroupInProgressActivity();
                })
                .each(function (activity) {
                    // make sure standards are sorted
                    activity.standards = _.sortBy(activity.standards, 'id');

                    // calculate needs attention
                    var needsAttentionCalculator = needsAttentionCalculators[activity.dblStandard.name];
                    activity.needsAttention = needsAttentionCalculator.needsAttention();
                })
                // show needs attention first.  sortBy is stable, so secondary sort on time desc
                // will remain.
                .sortBy(function (activity) {
                    return !activity.needsAttention;
                })
                .value();
        }

        function getNeedsAttentionCalculator (needsAttentionCalculators, dblStandardName) {
            var needsAttentionCalculator = needsAttentionCalculators[dblStandardName];
            if (!needsAttentionCalculator) {
                needsAttentionCalculator = new LessonGroupNeedsAttentionCalculator();
                needsAttentionCalculators[dblStandardName] = needsAttentionCalculator;
            }

            return needsAttentionCalculator;
        }

        function updateLessonGroupInProgressFromLessonComplete(lessonGroup, lessonComplete) {
            lessonGroup.lessonsInGroupCount++;

            addToTotalLessonTime(lessonGroup, lessonComplete);

            var standardsIndex = _.indexBy(lessonGroup.standards, 'id');
            _.each(lessonComplete.standards, function (standard) {
                standardsIndex[standard.id] = standard;
            });

            lessonGroup.standards = _.values(standardsIndex);
        }

        function addToTotalLessonTime(targetActivity, sourceActivity) {
            if (!isFinite(targetActivity.totalLessonTime)) {
                // If target doesn't have an addable time, just take from the source hoping
                // it's a better starting point.
                targetActivity.totalLessonTime = sourceActivity.totalLessonTime;
            } else if (isFinite(sourceActivity.totalLessonTime)) {
                // target and source have addable values so go for it!
                targetActivity.totalLessonTime += sourceActivity.totalLessonTime;
            }
        }

        return {
            addToTotalLessonTime: addToTotalLessonTime, // exposed for testing
            create: create,
            getLessonGroupsCompleted: getLessonGroupsCompleted,
            getLessonGroupsInProgress: getLessonGroupsInProgress,
            LessonGroupNeedsAttentionCalculator: LessonGroupNeedsAttentionCalculator // exposed for testing
        };
    }]);
